import { registerPlugin } from "@capacitor/core";
const ZendeskSDK = registerPlugin("ZendeskSDKPlugin", {
    web: () => import("./web").then((m) => new m.ZendeskSDKWeb()),
});
export * from "./definitions";
export { ZendeskSDK };
//# sourceMappingURL=index.js.map